import React, {useEffect, useRef, useState} from "react";
import {
    IonButton,
    IonContent,
    IonHeader, IonIcon,
    IonItem,
    IonLabel,
    IonPage, IonPopover, IonSelect, IonSelectOption, IonTextarea,
    IonTitle, IonToggle,
    IonToolbar
} from "@ionic/react";
import {AcaGetOpportunityResponseOpportunity, ContactType} from "../types";
import {warningOutline, warningSharp} from "ionicons/icons";

const ModalCloseOpportunity = ({dismiss, providerStates, isTier2, opportunity, contact}: { dismiss: (data?: { enrolled?: boolean, carrierProvider?: string | null, carrierState?: string | null, carrierMemberCount?: number | null, failedReasonCode?: string | null, failedNote?: string | null } | null | undefined | number, role?: string) => void, providerStates: {state:string, name: string}[], isTier2: boolean, opportunity:AcaGetOpportunityResponseOpportunity, contact: ContactType}) => {

    const [enrolled, setEnrolled] = useState<boolean>(false);
    const [carrierProvider, setCarrierProvider] = useState<string | null>(null);
    const [carrierState, setCarrierState] = useState<string | null>(null);
    const [carrierMemberCount, setCarrierMemberCount] = useState<number | null>(null);
    const [failedReasonCode, setFailedReasonCode] = useState<string | null>(null);
    const [failedNote, setFailedNote] = useState<string | null | undefined>(null);
    const [enrollmentEnabled, setEnrollmentEnabled] = useState<boolean>(false);
    const [issues, setIssues] = useState<string[]>([]);

    const [availableStates, setAvailableStates] = useState<string[]>([]);
    const [availableProviders, setAvailableProviders] = useState<string[]>([]);

    const modal = useRef<HTMLIonModalElement>(null);


    useEffect(() => {
        let states: string[] = [];
        providerStates.forEach((entry, index) => {
            if (!states.includes(entry.state)) {
                states.push(entry.state);
            }
        });
        setAvailableStates(states);

        let allowEnrollment = true;
        let tmpIssues: string[] = [];
        if (!isTier2) {
            allowEnrollment = false;
            tmpIssues.push('Only Tier 2 agents can mark an opportunity enrolled.');
        }
        if (!opportunity.aorSignedPdfId) {
            allowEnrollment = false;
            tmpIssues.push('Agent of Record consent required.');
        }
        if (!contact.addressLine1) {
            allowEnrollment = false;
            tmpIssues.push('Address Line 1 is required before attempting to enroll.');
        }
        if (!contact.addressCity) {
            allowEnrollment = false;
            tmpIssues.push('Address City is required before attempting to enroll.');
        }
        if (!contact.annualIncome && contact.annualIncome !== 0) {
            allowEnrollment = false;
            tmpIssues.push('Annual Income is required before attempting to enroll.');
        }
        if (!contact.employmentType) {
            allowEnrollment = false;
            tmpIssues.push('Employment Type is required before attempting to enroll.');
        }
        setIssues(tmpIssues);
        setEnrollmentEnabled(allowEnrollment);

    }, []);
    useEffect(() => {
        let providers: string[] = [];
        if (carrierState) {
            providerStates.forEach((entry, index) => {
                if (entry.state === carrierState) {
                    providers.push(entry.name);
                }
            });
            setAvailableProviders(providers);
        } else {
            setAvailableProviders([]);
        }
    }, [carrierState]);



    return (
        <IonPage ref={modal}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Close Opportunity</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">


                <p style={{verticalAlign: 'middle'}}><b>Is the contact enrolled successfully?</b>
                    &nbsp;&nbsp;
                    No
                    <IonToggle disabled={!enrollmentEnabled} style={{verticalAlign: 'middle'}} onIonChange={(e) => setEnrolled(e.detail.checked)}></IonToggle>
                    Yes
                    {issues && issues.length>0 &&
                        <>
                            <IonButton id="trigger-button" size="small" fill="clear" style={{color: 'orange', verticalAlign: 'middle'}} title="Incomplete information needed for enrollment. Click for more information.">
                                <IonIcon color="orange" md={warningOutline} ios={warningSharp}></IonIcon>
                            </IonButton>
                            <IonPopover trigger="trigger-button">
                                <IonContent className="ion-padding">
                                    <ul>
                                        {issues.map((issue, key) => {
                                            return (<li>{issue}</li>);
                                        })}
                                    </ul>
                                </IonContent>
                            </IonPopover>
                        </>
                    }
                </p>
                {enrolled &&
                    <div>
                        <p><b>Carrier State:</b>

                            <IonSelect style={{display: 'inline-block', maxWidth: '200px', marginLeft: '20px'}} label="Select Carrier State" labelPlacement="floating" fill="outline" value={carrierState} onIonChange={(e) => setCarrierState(e.detail.value)}>
                                {availableStates && availableStates.map((entry, index) => {
                                    return (
                                        <IonSelectOption key={'state_' + index} value={entry}>{entry}</IonSelectOption>
                                    )
                                })
                                }
                            </IonSelect>
                        </p>
                        <p><b>Carrier Provider:</b>
                            <IonSelect style={{display: 'inline-block', maxWidth: '200px', marginLeft: '20px'}} label="Select Provider" labelPlacement="floating" fill="outline" value={carrierProvider} onIonChange={(e) => setCarrierProvider(e.detail.value)}>
                                {availableProviders && availableProviders.map((entry, index) => {
                                    return (
                                        <IonSelectOption key={'provider_' + index} value={entry}>{entry}</IonSelectOption>
                                    )
                                })
                                }
                            </IonSelect>
                        </p>
                        <p><b>Carrier Member Count:</b>
                            <IonSelect style={{display: 'inline-block', maxWidth: '200px', marginLeft: '20px'}} label="Select Num Of Members" labelPlacement="floating" fill="outline" value={carrierMemberCount} onIonChange={(e) => setCarrierMemberCount(e.detail.value)}>
                                <IonSelectOption value="1">1</IonSelectOption>
                                <IonSelectOption value="2">2</IonSelectOption>
                                <IonSelectOption value="3">3</IonSelectOption>
                                <IonSelectOption value="4">4</IonSelectOption>
                                <IonSelectOption value="5">5</IonSelectOption>
                                <IonSelectOption value="6">6</IonSelectOption>
                                <IonSelectOption value="7">7</IonSelectOption>
                                <IonSelectOption value="8">8</IonSelectOption>
                            </IonSelect>
                        </p>

                    </div>
                }
                {!enrolled &&
                    <div>
                        <p><b>Reason Code:</b>
                            <IonSelect fill="outline" value={failedReasonCode} onIonChange={(e) => setFailedReasonCode(e.detail.value)}>
                                <IonSelectOption value="Competition">Competition</IonSelectOption>
                                <IonSelectOption value="Pricing/Cost">Pricing/Cost</IonSelectOption>
                                <IonSelectOption value="Incomplete Lead Data">Incomplete Lead Data</IonSelectOption>
                                <IonSelectOption value="No Response">No Response</IonSelectOption>
                                <IonSelectOption value="Income">Income</IonSelectOption>
                                <IonSelectOption value="Medicaid">Medicaid</IonSelectOption>
                                <IonSelectOption value="Medicare">Medicare</IonSelectOption>
                                <IonSelectOption value="Employer Benefits">Employer Benefits</IonSelectOption>
                                <IonSelectOption value="Duplicate">Duplicate</IonSelectOption>
                            </IonSelect>
                        </p>
                        <p><b>Other Notes:</b>
                            <IonTextarea fill="outline" value={failedNote} onIonChange={(e) => setFailedNote(e.detail.value)} rows={8} style={{marginTop: '10px'}}></IonTextarea>
                        </p>
                    </div>
                }

                <p style={{textAlign: 'right'}}>
                    <IonButton onClick={() => dismiss(null, 'cancel')} fill="outline">Cancel</IonButton>
                    <IonButton strong={true} onClick={() => dismiss({
                        enrolled,
                        carrierProvider,
                        carrierState,
                        carrierMemberCount,
                        failedReasonCode,
                        failedNote
                    }, 'confirm')}>
                        Confirm
                    </IonButton>
                </p>
            </IonContent>
        </IonPage>);
};

export default ModalCloseOpportunity;